import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { post } from '../http';
import { activeSnack } from './common';

// import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const getAllReports = createAsyncThunk(
  'report/list',
  async ({ page, search, dispatch, limit, state, date }) => {
    try {
      const response = await post(
        `/report/admin/all?page=${page && page}&search=${search && search}&limit=${
          limit || 5
        }&dateFrom=${date?.from || ''}&dateTo=${date?.to || ''}`,
        state
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const ReportsSlice = createSlice({
  name: 'reports',
  initialState: {
    loading: false,
    error: {},
    // staff
    reports: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllReports.pending]: (state) => {
      state.loading = true;
    },
    [getAllReports.fulfilled]: (state, action) => {
      state.loading = false;
      state.reports = action.payload;
      state.error = {};
    },
    [getAllReports.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = ReportsSlice.actions;

export default ReportsSlice.reducer;
